import { Component, OnInit } from '@angular/core';
//[0,6,10,18,24,28]
let a = [3,5,8,12,13.5,0].map(x=>360*(x/37))
@Component({
  selector: 'app-multi-sector-band-disc',
  templateUrl: './multi-sector-band-disc.component.html',
  styleUrls: ['./multi-sector-band-disc.component.css']
})
export class MultiSectorBandDiscComponent implements OnInit {
  public bands = [
    {offset: -2, angles : a, words: []},
    {offset:  2.5, words: ['Einsam','Verletzlich','Verzweiflung','Schuldbewusst','Depressiv','Verletzt','Abgestossen','Furchtbar','Enttäuscht','Missbilligend','Kritisch','Distanziert','Frustriert','Aggressiv','Verärgert','Verbittert','Gedemütigt','Allein gelassen','Bedroht','Abgelehnt','Schwach','Unsicher','Beklommen','Eingeschüchtert','Verdutzt','Verwirrt','Verblüfft','Aufgeregt','Verspielt','Zufrieden','Interessiert','Stolz','Angenommen','Leistungsfähig','Friedvoll','Vertrauend', 'Optimistisch']},
    {offset: 9.73-9.73, words: ['Isoliert','Verlassen','Schikaniert','Zerbrechlich','Trauernd','Macht- und Kraftlos','Reumütig','Beschämt','Minderwertig','Leer','Beschämt','Enttäuscht','Zögernd','Entsetzt','Angeekelt','Abscheu','Abgestoßen','Erschüttert','Widerwillig','Ablehnend','Skeptisch','Abweisend','Empfindungslos','Verschlossen','Verärgert','Wütend','Feindlich','Gereizt','Eifersüchtig','Rasend','Gestört','Empört','Verhöhnt','Verachtet','Gekränkt','Verraten','Nervös','Ungeschützt','Ausgeschlossen','Verfolgt','Wertlos','Unbedeutend','Unzulänglich','Unterlegen','Überfordert','Besorgt','Hilflos','Verängstigt','Schockiert','Bestürzt','Desillusioniert','Fassungslos','Erstaunt','Ehrfürchtig','Ungeduldig','Energiegeladen','Erregt','Frech','Frei','Freudig','Neugierig','Wissbegierig','Erfolgreich','Zuversichtlich','Respektiert','Wertgeschätzt','Mutig','Kreativ','Liebend','Dankbar','Offen','Vertrauend', 'Hoffnungsvoll', 'Inspiriert']}
  ];
  public bandwidth = 200;
  constructor() {
   }

  ngOnInit() {
  }

}



